import { action } from 'mobx';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '@link/share/constants';
import { BaseAuth } from '@link/share/stores';
import { type UserCredential } from '@link/share/vendors/firebase';
import authApi from '@link/triplabo/services/endpoints/auth';

const storage = localStorage;

export class Auth extends BaseAuth {
  @action
  setAccessToken(accessToken?: string) {
    if (accessToken) {
      this.accessToken = accessToken;
      storage.setItem(ACCESS_TOKEN, accessToken);
    }
  }

  @action
  getAccessToken() {
    return this.accessToken;
  }

  @action
  setRefreshToken(refreshToken?: string) {
    if (refreshToken) {
      this.refreshToken = refreshToken;
      storage.setItem(REFRESH_TOKEN, refreshToken);
    }
  }

  @action
  async refreshExpiredToken() {
    return authApi
      .refreshToken({
        body: {
          refreshToken: this.refreshToken
        }
      })
      .then(res => {
        if (res.accessToken) {
          this.setAccessToken(res.accessToken);
        }
        if (res.refreshToken) {
          this.setRefreshToken(res.refreshToken);
        }
        return res.accessToken;
      });
  }

  @action
  async exchangeToken(token: string) {
    return authApi.exchangeToken({
      body: {
        token
      }
    });
  }

  @action
  async updateToken(credential: UserCredential) {
    const firebaseToken = await credential.user.getIdToken();
    const res = await this.exchangeToken(firebaseToken);
    if (res?.accessToken) this.setAccessToken(res.accessToken);
    if (res?.refreshToken) this.setRefreshToken(res.refreshToken);
  }
}

export default new Auth();
